export default "__VITE_ASSET__Cjxm23iR__"